import { z } from 'zod';
// Every supported cockpit language. Values are absent while a translation is still pending, so consumers
// must fall back to another language rather than assume the selected one is present.
export const localizedTextSchema = z
    .object({
    'de-CH': z.string(),
    'fr-CH': z.string(),
    'it-CH': z.string(),
    'en-CH': z.string(),
})
    .partial();
export const LOCALIZED_TEXT_LANGUAGES = ['de-CH', 'fr-CH', 'it-CH', 'en-CH'];
// Falls back to any other language rather than showing nothing while a translation is still pending, and
// names the language it settled on so a caller can tell the reader when it is not the one they asked for.
export function resolveLocalizedText(text, language) {
    if (!text) {
        return undefined;
    }
    for (const candidate of [language, ...LOCALIZED_TEXT_LANGUAGES]) {
        const value = text[candidate];
        if (value) {
            return { text: value, language: candidate };
        }
    }
    return undefined;
}
export function pickLocalizedText(text, language) {
    return resolveLocalizedText(text, language)?.text ?? '';
}
// True while a machine translation is still outstanding: some language has text and some does not.
export function isAwaitingTranslation(text) {
    if (!text) {
        return false;
    }
    const present = LOCALIZED_TEXT_LANGUAGES.map((language) => Boolean(text[language]));
    return present.some(Boolean) && !present.every(Boolean);
}
